import { Inject, Injectable } from '@angular/core';
import { GlobalConfigService } from '@services/global-config-service';
import { LanguageData, SimplyLinkItem } from '@types';
import { TranslateService } from '@shared/translate/translate.service';
import { WINDOW } from '@ng-web-apis/common';
import { Page } from '@bloomreach/spa-sdk';
import { LanguageSelector } from '@frk/eds-components';

type Language = {
  label: string;
  language: string;
  url: string;
};

@Injectable({
  providedIn: 'root',
})
export class LanguageSelectorService {
  private languages: Language[] = [];
  constructor(
    private globalConfigService: GlobalConfigService,
    private translateService: TranslateService,
    @Inject(WINDOW) readonly windowRef: Window
  ) {
    this.setLanguages();
  }

  /**
   * Set languages array
   */
  private setLanguages(): void {
    const languageData = this.globalConfigService.getLanguages();
    if (languageData) {
      this.languages = languageData.map((language: LanguageData) => {
        return {
          label: this.translateService.instant('languages.' + language.locale),
          language: language.locale,
          url: language.url,
        };
      });
    }
  }

  /**
   * Get Language options for language selector (eds-flyout-menu)
   */
  public getLanguageOptions(page: Page): LanguageSelector {
    const convertedLanguages: SimplyLinkItem[] = this.getConvertedLanguages();
    if (convertedLanguages.length > 0) {
      return {
        title: this.getChannelLanguageLabel(page),
        items: convertedLanguages,
      };
    }
  }

  /**
   * Returns languages array
   */
  public getLanguages(): Language[] {
    return this.languages;
  }

  /**
   * Set Channel language label
   * @param page - BR page
   */
  public getChannelLanguageLabel(page: Page): string {
    const channelParams = page.getChannelParameters();
    return (
      this.translateService.instant('languages.' + channelParams?.Language) ||
      'Language'
    );
  }

  /**
   * Returns languages array required for EDS component
   */
  public getConvertedLanguages(): SimplyLinkItem[] {
    const languagesEds = [];
    this.languages.forEach((language: Language) => {
      const simplyItem: SimplyLinkItem = {
        link: language.label,
        href: this.windowRef.location.origin + (language.url || '#'),
        eventParams: { link_text: language.label },
      };
      languagesEds.push(simplyItem);
    });
    return languagesEds;
  }
}
